export default {
  title: 'Companies',
  contactsView: {
    deleteTitle: 'List of registered contacts to delete',
    success: 'The contacts were succesfully removed.'
  },
  contact: {
    new: 'New',
    data: 'Enter the details of the new contact',
    add: 'Add to'
  },
  table: {
    saveNew: 'Save as new element',
    createAndSelect: 'Create and select',
    updateAndSelect: 'Update and select',
    undo: 'Undo changes',
    select: 'Select',
    noResults: 'No results found',
    document: 'VAT Number',
    reason: 'Company Name/Name',
    nameSurname: 'Trade name/Surnames',
    department: 'Department',
    departmentCode: 'Department',
    managerbodyCode: 'Manager code',
    managerbodyDescription: 'Manager description',
    receiverCode: 'Receiver code',
    costCenter: 'Cost center'
  },
  searchContact: {
    title: 'Directory',
    search: 'Search in directory',
    showing: 'Showing',
    document: 'ID/VAT Number',
    reason: 'Company Name/Name',
    nameSurname: 'Trade name/Surnames',
    more: 'Show more',
    addSelected: 'Add selected',
    allContacts: 'All contacts',
    bankiaContacts: 'Bankia Contacts',
    deleteTitle: 'Summary of selected contact to delete',
    deleteConfirm: 'Are you sure you want to delete the selected contacts?',
    department: 'Department',
    managerbodyCode: 'Manager code',
    managerbodyDescription: 'Manager description',
    receiverCode: 'Receiver code'
  },
  button: {
    newElement: 'New company'
  }
}
